import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PortalHotelBooking } from '@app/services/api/api.types';

@Component({
  selector: 'hotel-bookings-tooltip',
  templateUrl: './hotel-bookings-tooltip.component.html',
  styleUrls: ['./hotel-bookings-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HotelBookingsTooltipComponent {
  @Input() hotelBookings: PortalHotelBooking[];
}
